import * as React from 'react'

export const TriangleAlertIcon = ({
  className,
  fill = 'none',
}: {
  className?: string
  fill: string
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 2.25C8.32812 2.25 8.63281 2.4375 8.79688 2.71875L13.8594 11.3438C14.0234 11.6484 14.0234 12 13.8594 12.2812C13.6953 12.5859 13.3906 12.75 13.0625 12.75H2.9375C2.58594 12.75 2.28125 12.5859 2.11719 12.2812C1.95312 12 1.95312 11.6484 2.11719 11.3438L7.17969 2.71875C7.34375 2.4375 7.64844 2.25 8 2.25ZM8 5.25C7.67188 5.25 7.4375 5.50781 7.4375 5.8125V8.4375C7.4375 8.76562 7.67188 9 8 9C8.30469 9 8.5625 8.76562 8.5625 8.4375V5.8125C8.5625 5.50781 8.30469 5.25 8 5.25ZM8.75 10.5C8.75 10.1016 8.39844 9.75 8 9.75C7.57812 9.75 7.25 10.1016 7.25 10.5C7.25 10.9219 7.57812 11.25 8 11.25C8.39844 11.25 8.75 10.9219 8.75 10.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
